<template>
  <div class="sidebar-overlay" v-if="showSidebar" @click="toggleSidebar()"></div>
  <nav class="sidebar" :class="{ 'sidebar-visible': showSidebar, 'sidebar-hidden': !showSidebar }">
  <div style="overflow-y: auto;">
    <ul class="nav flex-column">
      
      <!-- Quick Actions -->
      <li class="nav-item position-relative pt-3">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openRequestModal()">
          <span>
            <PlusCircle :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">New Request</span>
          </span>
        </a>
      </li>
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1" href="#" @click.prevent="openAssignmentModal()">
          <span>
            <CheckSquare :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">New Task</span>
          </span>
        </a>
      </li>
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/clock/list">
          <span>
            <Clock :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Time Tracker</span>
          </span>
        </router-link>
      </li>
      
      <li><hr /></li>
      
      <!-- Activity Log -->
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/home">
          <span>
            <RotateCcw :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Activity Log</span>
          </span>
        </router-link>
      </li>

      <!-- Projects Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('projects')">
          <span>
            <FolderOpen :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Projects</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'projects' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'projects' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/request/list">
              <span>
                <ClipboardList :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Requests</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/job/list">
              <span>
                <FileText :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Work Orders</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/estimates">
              <span>
                <FileText :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Estimates</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/workorders">
              <span>
                <List :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Invoices</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/pm/list">
              <span>
                <Wrench :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">PM List</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/assignments/list">
              <span>
                <ClipboardList :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">All Tasks</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/work/list">
              <span>
                <CheckSquare :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">All Work</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/part/list">
              <span>
                <Package :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">All Parts</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/expense/list">
              <span>
                <Banknote :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">All Expenses</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/mileage/list">
              <span>
                <Car :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">All Mileage</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>

      <!-- Company Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('company')">
          <span>
            <Building :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Company</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'company' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'company' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/tech/list">
              <span>
                <Users :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Technicians</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/client/list">
              <span>
                <Building :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Customers</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/calendar">
              <span>
                <Calendar :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Calendar</span>
              </span>
            </router-link>
          </li>
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/notification/list">
              <span>
                <Bell :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Notifications</span>
                <span v-if="unreadCount > 0" class="badge bg-danger ms-2">{{ unreadCount }}</span>
              </span>
            </router-link>
          </li>
          <!-- TODO  -->
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/forms">
              <span>
                <FileEdit :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Documents</span>
              </span>
            </router-link>
          </li>
          
        </ul>
      </li>

      <!-- Reports Accordion -->
      <li class="nav-item position-relative">
        <a class="nav-link py-0 -ps-1 accordion-toggle" href="#" @click.prevent="toggleAccordion('reports')">
          <span>
            <BarChart2 :size="20" class="position-absolute mt-1" />
            <span class="d-inline-block ms-4 ps-2">Reports</span>
            <ChevronRight :size="16" class="accordion-chevron" :class="{ 'rotated': openAccordion === 'reports' }" />
          </span>
        </a>
        <ul class="nav flex-column accordion-content" :class="{ 'open': openAccordion === 'reports' }">
          <li class="nav-item position-relative">
            <router-link class="nav-link py-0 -ps-1 sub-item" to="/reports/work">
              <span>
                <FileText :size="18" class="position-absolute mt-1" />
                <span class="d-inline-block ms-4 ps-2">Work Report</span>
              </span>
            </router-link>
          </li>
        </ul>
      </li>
      
      <li><hr /></li>
    </ul>
  </div>
  <div>
    <ul class="nav flex-column">
      <li class="nav-item position-relative">
        <router-link class="nav-link py-0 -ps-1" to="/logout">
          <span>
          <LogOut :size="20" class="position-absolute mt-1" />
          <span class="d-inline-block ms-4 ps-2">Logout</span>
          </span>
        </router-link>
      </li>
    </ul>
    <div class="version d-flex align-items-center justify-content-between">
      <span>v{{ appVersion }}</span>
      <a href="#" class="refresh-link" @click.prevent="refreshApp" title="Clear cache and reload">
        <RefreshCw :size="14" /> Refresh
      </a>
    </div>
  </div>
  </nav>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { RouterLink } from "vue-router";
import Emitter from "@/services/Emitter";
import ApiService from "@/services/ApiService";
import { 
  PlusCircle, 
  CheckSquare, 
  FileText, 
  List, 
  Building, 
  Users, 
  Calendar, 
  Package, 
  Banknote, 
  Car, 
  Wrench, 
  Clock, 
  RotateCcw, 
  LogOut,
  ClipboardList,
  ChevronRight,
  FolderOpen,
  BarChart2,
  Bell,
  FileEdit,
  RefreshCw
} from 'lucide-vue-next';

const appVersion = __APP_VERSION__;

const isMobile = () => window.innerWidth <= 768;
const showSidebar = ref(!isMobile());
const openAccordion = ref<string | null>(null);
const unreadCount = ref(0);

const loadUnreadCount = async () => {
  try {
    unreadCount.value = await ApiService.getUnreadNotificationCount(true);
  } catch (error) {
    console.error('Error loading unread count:', error);
  }
};

onMounted(() => {
  loadUnreadCount();
  // Emit initial sidebar state so layout knows if sidebar is visible
  Emitter.emit("sidebar-state", showSidebar.value);
});

Emitter.on("notification:refresh", loadUnreadCount);

const toggleSidebar = () => {
  showSidebar.value = !showSidebar.value;
  Emitter.emit("sidebar-state", showSidebar.value);
};

const toggleAccordion = (section: string) => {
  if (openAccordion.value === section) {
    openAccordion.value = null;
  } else {
    openAccordion.value = section;
  }
};

Emitter.on("sidebar", toggleSidebar);

const openJobModal = () => {
  Emitter.emit("open:requestForm");
};

const openAssignmentModal = () => {
  Emitter.emit("open:taskForm");
};

const openRequestModal = () => {
  Emitter.emit("open:requestForm");
};

const refreshApp = async () => {
  // Clear caches and do a hard refresh
  if ('caches' in window) {
    try {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
      console.log('Caches cleared');
    } catch (e) {
      console.error('Failed to clear caches:', e);
    }
  }
  
  // Clear localStorage app-specific items (preserve auth)
  const keysToKeep = ['token', 'user'];
  const keysToRemove: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && !keysToKeep.includes(key)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
  
  // Hard refresh bypassing cache
  window.location.reload();
};
</script>

<style scoped>
.sidebar {
  width: 300px;
  max-width: 300px;
  background-color: rgb(34,30,31);
  background-color: #132341;
  color: #ffffff;
  height: calc(100vh - 70px);
  position: fixed;
  top: 70px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index:1000;
  transition: transform 0.3s ease-in-out;
}

.sidebar-visible {
  transform: translateX(0);
}

.sidebar-hidden {
  transform: translateX(-100%);
}
.sidebar .nav-link {
  color: #adb5bd;
  /* padding: 0.75rem 1.5rem; */
}

.sidebar .nav-link > span {
  display: block;
  padding: 0.75rem 1.5rem;
  position: relative;
  overflow: hidden;
  /* border-radius: 50px; */
}

/* Hover effect - aquamarine green badge style */
.sidebar .nav-link:hover > span {
  color: #ffffff;
  background-color: #3B9796;
  transition: background-color 0.2s ease;
}

.sidebar .nav-link:hover > span svg {
  color: #ffffff;
}

/* Commented out: Glow/shimmer hover effect
.sidebar .nav-link:hover > * {
  color: #ffffff; 
  transition: padding-left 0.4s;
  padding-left: 2rem!important;
}
.sidebar .nav-link:hover > *:not(span) {
  color: #BF092F!important;
}

.sidebar .nav-link:hover > span {
  background-color: #495057;
  box-shadow: inset 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.sidebar .nav-link:hover > span i:last-child {
  display: inline-block!important;
}

.sidebar .nav-link:hover > span::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.3) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.5s ease-in-out;
  pointer-events: none;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
*/

/* Active page styles - match hover state */
.sidebar .nav-link.router-link-active > span {
  color: #ffffff;
  background-color: #3B9796;
}

.sidebar .nav-link.router-link-active > span svg {
  color: #ffffff;
}

.sidebar .version {
  padding: 0.75rem 1rem;
  color: #6c757d;
  font-size: 0.8rem;
}

.sidebar .version .refresh-link {
  color: #6c757d;
  text-decoration: none;
  font-size: 0.75rem;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  transition: color 0.2s ease;
}

.sidebar .version .refresh-link:hover {
  color: #3B9796;
}

.sidebar-overlay {
  position: fixed;
  top: 70px;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index:999;
}

@media (min-width: 769px) {
  .sidebar-overlay {
    display: none; /* No overlay needed on desktop */
  }
}

/* Accordion styles */
.accordion-toggle > span {
  display: flex;
  align-items: center;
}

.accordion-chevron {
  position: absolute;
  right: 1.5rem;
  transition: transform 0.3s ease;
}

.accordion-chevron.rotated {
  transform: rotate(90deg);
}

.accordion-content {
  max-height: 0;
  overflow: hidden;
  opacity: 0;
  transition: max-height 0.3s ease-out, opacity 0.3s ease-out;
  background-color: rgba(0, 0, 0, 0.25);
  box-shadow: inset 0 4px 8px rgba(0, 0, 0, 0.3);
}

.accordion-content.open {
  max-height: 500px;
  opacity: 1;
  transition: max-height 0.4s ease-in, opacity 0.4s ease-in;
}

.accordion-content .sub-item > span {
  padding-left: 1.5rem !important;
}
</style>